/* Reflect the product's XB Wishlist count; no generated or cached counts. */
(() => {
  let observer, queued = false;
  function readCount(source) {
    // Use the displayed count first, including updates after adding/removing an item.
    const label = source.querySelector('.xb-wishlist-button__text');
    const match = label?.textContent.trim().match(/\(([\d\s.,\u00a0\u202f]+)\)\s*$/u);
    const raw = match ? match[1].replace(/[\s.,\u00a0\u202f]/gu, '') : source.getAttribute('xb-count');
    if (raw === null || !/^\d+$/.test(raw)) return null;
    const count = Number(raw);
    return Number.isSafeInteger(count) ? count : null;
  }
  function update() {
    queued = false;
    document.querySelectorAll('[data-vnk-wishlist-interest]').forEach(element => {
      const scope = element.closest('[data-section-type="product"]') || element.closest('.shopify-section') || document;
      const source = [...scope.querySelectorAll('xb-wishlist-button[xb-product-id]')]
        .find(button => button.getAttribute('xb-product-id') === element.dataset.productId);
      const count = source ? readCount(source) : null;
      const stock = element.getAttribute('data-stock-total');
      const eligible = stock !== null && /^\d+$/.test(stock) && Number(stock) <= 1;
      const text = eligible && count >= 2 ? `Bereits auf ${count.toLocaleString('de-DE')} Wunschlisten` : '';
      const target = element.querySelector('[data-vnk-wishlist-text]');
      if (target && target.textContent !== text) target.textContent = text;
      element.hidden = !text;
    });
  }
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(update);
  }
  function init() {
    if (observer) return;
    update();
    observer = new MutationObserver(records => {
      const relevant = records.some(record => {
        const node = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        if (record.type === 'attributes' && record.attributeName === 'data-stock-total') return true;
        if (node?.closest('[data-vnk-wishlist-interest]')) return false;
        if (record.type === 'attributes') return true;
        if (node?.closest('xb-wishlist-button')) return true;
        return [...record.addedNodes, ...record.removedNodes].some(item => item.nodeType === 1 &&
          (item.matches('xb-wishlist-button,[data-vnk-wishlist-interest]') || item.querySelector('xb-wishlist-button,[data-vnk-wishlist-interest]')));
      });
      if (relevant) schedule();
    });
    observer.observe(document.body, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['xb-count','xb-product-id','data-stock-total']});
  }
  function cleanup() { observer?.disconnect(); observer = null; queued = false; }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('pagehide', cleanup);
  window.addEventListener('pageshow', () => { init(); schedule(); });
})();
